export interface CaseStudyGermanDetail {
  challenge: string;
  solution: string;
  impact: string[];
  quote?: string;
}

export const caseStudyGermanDetails: Record<string, CaseStudyGermanDetail> = {
  "deeptrait-ngs-data-analysis": {
    challenge:
      "Die Analyse von Next-Generation-Sequencing-Daten erforderte Bioinformatiker mit fortgeschrittenen Programmierkenntnissen. Laborteams mussten mehrere Tage auf Ergebnisse warten und konnten genomische Datensätze weder selbstständig untersuchen noch statistische Tests durchführen oder Varianten annotieren. Dadurch entstanden erhebliche Engpässe in präklinischen Wirkstoffforschungsprozessen.",
    solution:
      "Wir haben DeepTrait mitgegründet und entwickelt: eine No-Code-Plattform für NGS-Datenanalyse, von Laborspezialisten für Laborspezialisten. Die Plattform unterstützt Kolmogorov-Smirnov-Tests, ROC-Analysen, die nahtlose Varianten- und Genannotation über alle wichtigen Datenbanken hinweg sowie die Identifikation genetisch gestützter therapeutischer Targets und diagnostischer Marker. Forschende gelangen so in weniger als sechs Stunden von Rohdaten zu verwertbaren Erkenntnissen.",
    impact: [
      "Verkürzung der NGS-Analysezeit von mehreren Tagen auf unter 6 Stunden",
      "Deutlich geringere Abhängigkeit von Bioinformatikern bei Routineanalysen",
      "Beschleunigte Identifikation neuer therapeutischer Targets und diagnostischer Marker",
      "Unterstützung der wichtigsten Datenbanken für Varianten- und Genannotation",
    ],
    quote:
      "DeepTrait hat grundlegend verändert, wie unsere Laborteams mit Genomdaten arbeiten.",
  },
  "astrazeneca-medical-affairs-ai": {
    challenge:
      "AstraZeneca musste die Effizienz seiner Medical-Affairs-Analysen erhöhen und tiefere Erkenntnisse aus den umfangreichen CRM-Daten der Medical Science Liaisons gewinnen. Der bestehende manuelle Prozess war zeitaufwendig und brachte nur begrenzt verwertbare Muster ans Licht.",
    solution:
      "Wir haben ein KI-Produkt entwickelt, das die Analyse von CRM-Datensätzen automatisiert, strukturierte Übersichten liefert und verwertbare Erkenntnisse aus groß angelegten Medical-Affairs-Abläufen ableitet. Zur Lösung gehörte außerdem eine Insights-Pipeline, die sowohl für Außendienstteams als auch für das Headquarter Mehrwert schafft.",
    impact: [
      "Schnellere und präzisere datengetriebene Entscheidungen",
      "Höhere kommerzielle und operative Effizienz",
      "Transformation komplexer CRM-Daten in ein strategisches Asset",
      "Vereinfachte Workflows und neue Nutzungsmöglichkeiten für Insights",
    ],
    quote: "Sie verfügten über ein phänomenales KI-Know-how.",
  },
  "civitta-ai-accelerator-consulting": {
    challenge:
      "Civitta, ein führendes internationales Beratungsunternehmen, wollte die Startups seines Challenger AI Accelerators mit belastbaren KI-Produktstrategien und klaren Roadmaps ausstatten, damit sie im Bereich Generative AI nachhaltige Wettbewerbsvorteile aufbauen können.",
    solution:
      "Wir haben für vier Startups in drei Ländern umfassende KI-Produktstrategien und umsetzbare Implementierungspläne entwickelt. Dazu gehörten detaillierte Systemarchitekturen für sichere, skalierbare und effiziente Deployments von Generative-AI-Lösungen.",
    impact: [
      "Lösung zentraler KI-Technologieherausforderungen für alle vier Startups",
      "Lieferung von KI-Produktstrategien inklusive Go-to-Market-Plänen",
      "Entwurf skalierbarer GenAI-Architekturen für jedes Team",
      "Erstellung passender Multi-Cloud-Deployment-Blueprints pro Startup",
    ],
    quote:
      "Beeindruckend war, wie Shelpuk AI Technology Consulting für jedes betreute Team einen spezifischen Ansatz gefunden hat.",
  },
  "xfusion-rag-chatbot": {
    challenge:
      "xFusion Technologies wollte die xAQUA®-Plattform weiterentwickeln, damit Nutzer sofort präzise und kontextbezogene Antworten aus komplexen Unternehmensdokumenten in DOCX-, PDF- und TXT-Formaten erhalten können.",
    solution:
      "Wir haben ein dokumentenbasiertes Suchsystem mit LangChain entwickelt und in eine Postgres-Datenbank mit pgvector integriert. Die Lösung unterstützt OpenAI-Modelle wie ChatGPT und GPT-4 und bietet zugleich eine Plug-and-Play-Integration mit Llama-2, Mistral und weiteren Open-Source-LLMs.",
    impact: [
      "Drastisch reduzierte Zeit für die Suche nach geschäftskritischen Informationen",
      "Besser informierte Entscheidungen durch schnellen Zugang zu relevanten Inhalten",
      "Stärkung des Wettbewerbsvorteils der xAQUA®-Plattform",
      "Auslieferung als wiederverwendbares und leicht integrierbares Python-Paket",
    ],
    quote:
      "Ihre Kompetenz, ihr Wille, die richtige Lösung zu bauen, ihr Verantwortungsbewusstsein und ihre Reaktionsgeschwindigkeit sind beeindruckend.",
  },
  "periodix-lead-generation-ai": {
    challenge:
      "Periodix wollte seine Lead-Generation deutlich ausbauen und dafür einen maßgeschneiderten KI-Vertriebsassistenten entwickeln, der Interessenten mit personalisierten und wirkungsvollen Interaktionen anspricht.",
    solution:
      "Wir haben ein individuelles Llama-2-Konversationsmodell auf leistungsstarken Vertriebsdialogen trainiert und ein flexibles Deployment-Konzept entworfen, das spätere Updates und Anpassungen vereinfacht. Die Lösung wurde als cloudfähige Produktionskomponente ausgeliefert.",
    impact: [
      "Relevantere und stärker personalisierte Interaktionen mit Interessenten",
      "Bessere Erfassung von Leads mit hoher Kaufabsicht",
      "Einfachere langfristige Modell-Upgrades und Modellwechsel",
      "Termingerechte Lieferung einer neuen Kernfunktion",
    ],
    quote:
      "Sie hatten die Fähigkeit, komplexe Themen auf die denkbar einfachste Weise zu erklären.",
  },
  "dynamiq-genai-platform-strategy": {
    challenge:
      "Dynamiq, eine führende Generative-AI-Plattform, suchte nach einer fortgeschrittenen KI-Strategie, um das Produktangebot auszubauen, die Nutzerbindung zu vertiefen und die operative Effizienz in einem sich schnell verändernden Markt zu verbessern.",
    solution:
      "Wir haben eine anspruchsvolle KI-Strategie definiert und umgesetzt, die die Entwicklung spezifischer generativer Modelle, Fine-Tuning auf Dynamiqs proprietären Daten, Marktanalyse, Wettbewerbsbenchmarking und RAG-Integration kombiniert.",
    impact: [
      "Ausbau des Produktangebots um moderne Generative-AI-Funktionen",
      "Höhere Nutzerbindung und Zufriedenheit durch kontextbezogene Antworten",
      "Effizientere Recherche- und Wissenszugriffsprozesse",
      "Insgesamt gesteigerte operative Effizienz",
    ],
    quote:
      "Die strategische Weitsicht, technische Stärke und Unterstützung des Teams waren entscheidend für den Erfolg unserer Initiativen.",
  },
  "axbio-questionnaire-analysis": {
    challenge:
      "Axbio benötigte ein automatisiertes und skalierbares System, um Gesundheitsfragebögen zu erfassen, Antworten mit einem gewichteten Scoring-Modell auszuwerten und personalisierte Berichte zu versenden. Gleichzeitig sollten nicht-technische Teams die Inhalte der Fragebögen eigenständig verwalten können.",
    solution:
      "Wir haben eine cloud-native Prozesskette aufgebaut, die Microsoft Forms für das Fragebogenmanagement, Power Automate für die Orchestrierung der Antworten und einen Python-Microservice auf Azure Container Apps für die Verarbeitung nutzt. Azure OpenAI erstellt personalisierte Berichte auf Basis der gewichteten Analyse, Azure Communication Services übernimmt den Versand per E-Mail.",
    impact: [
      "Vollständig automatisierte Kette von der Fragebogeneinreichung bis zum Versand personalisierter Berichte",
      "Pflege von Fragen und Gewichtungen durch nicht-technische Teams ohne Entwicklerunterstützung",
      "Automatische Erstellung personalisierter Gesundheitsberichte für jede befragte Person",
      "Skalierbare Cloud-Architektur auf Azure Container Apps",
    ],
    quote:
      "Das System ermöglicht es uns, personalisierte Gesundheits-Insights in großem Maßstab mit minimalem manuellem Aufwand bereitzustellen.",
  },
  "pumb-retail-banking-ai-strategy": {
    challenge:
      "Eine große Retailbank benötigte eine umfassende KI-Strategie als Teil ihrer Geschäftsstrategie. Ziel war es, Use Cases nach Wirkung, Machbarkeit, Kosten und Potenzial für einen nachhaltigen Vorteil zu bewerten und zu priorisieren.",
    solution:
      "Wir haben die vollständige KI-Strategie konzipiert, inklusive Wettbewerbsanalyse, Gap Analysis, Bewertung bestehender KI-Praktiken, Prüfung strategischer Optionen und konkreter Empfehlungen. Zusätzlich haben wir das Kundenteam bei der Entwicklung von KI-Modellen für Marketing und CRM begleitet, darunter CLV, Verhaltenstargeting, A/B-Testing und personalisierte Empfehlungen.",
    impact: [
      "Umsetzung oder Start der Umsetzung für den Großteil der Empfehlungen",
      "Aufbau und Besetzung eines AI-/Data-Science-Teams entsprechend der empfohlenen Strategie",
      "Verbesserung von Konversionsraten und kreditbezogenen Finanzkennzahlen",
      "Deutlich bessere Modellmetriken im Marketing und CRM",
      "Einführung neuer Modelle entlang der Prioritätenmatrix aus Wirkung und Investition",
    ],
    quote:
      "Sie hatten das Talent, mit direkter Kommunikation und bei Bedarf auch mit Humor eine positive Dynamik aufrechtzuerhalten.",
  },
  "bank-rag-chatbot": {
    challenge:
      "Die Bank musste Mitarbeitenden und Stakeholdern ermöglichen, schnell präzise und kontextbezogene Antworten aus einem großen Bestand interner Dokumente aus verschiedenen Geschäftsbereichen zu erhalten. Die manuelle Suche war langsam und lieferte häufig unvollständige oder irrelevante Ergebnisse.",
    solution:
      "Wir haben ein vollständiges RAG-System konzipiert und geliefert, bestehend aus einer Python-Bibliothek mit Komponenten für Dokumenten- und Konversationsmanagement, einem containerisierten Flask-Microservice mit RESTful APIs sowie einem Ingestion-Tool zum Laden von mehr als 3.200 Dokumenten. Das System unterstützt Multi-Turn-Konversationen, die Verarbeitung bildhaltiger Dokumente und mehrere Gesprächsmodi.",
    impact: [
      "Mehr als 3.200 Dokumente per semantischer Suche erschlossen und durchsuchbar gemacht",
      "Unterstützung von Multi-Turn-Konversationen mit kontextbezogenen Antworten",
      "Bildanalyse für Diagramme und visuelle Elemente in Dokumenten",
      "Produktionsreifer containerisierter Microservice mit Docker-Deployment",
    ],
  },
};
